<div class="item-table-container" [style.font-family]="fontFamily">
  @if (loaded$ | async) {
    @if (showItems$ | async) {
      @if (itemTableWidget.transition === 'fade-in') {
        @let pageIndex = pageIndex$ | async;
        @for (page of [pageIndex]; track $index) {
          <div
            class="item-grid fade-in"
            [style.grid-template-columns]="'repeat(' + (itemTableWidget.columns || 1) + ', minmax(0, 1fr))'"
            [style.grid-template-rows]="'repeat(' + (itemTableWidget.rows || 1) + ', minmax(0, 1fr))'"
          >
            @for (item of displayItems$ | async; track item.uuid) {
              @if (itemTableWidget.card_type === ItemTableCardType.STANDARD_TABLE) {
                <gb-presenter-widget-item-table-card-standard
                  [item]="item"
                  [itemTableWidget]="itemTableWidget"
                  [itemTypeTranslateKey]="getItemTypeTranslateKey(item)"
                ></gb-presenter-widget-item-table-card-standard>
              }
              @if (itemTableWidget.card_type === ItemTableCardType.COMPACT_TABLE) {
                <gb-presenter-widget-item-table-card-compact
                  [item]="item"
                  [itemTableWidget]="itemTableWidget"
                  [itemTypeTranslateKey]="getItemTypeTranslateKey(item)"
                ></gb-presenter-widget-item-table-card-compact>
              }
            }
          </div>
        }
      }
      @if (
        itemTableWidget.transition === 'scroll-left' ||
        itemTableWidget.transition === 'scroll-right' ||
        itemTableWidget.transition === 'scroll-up' ||
        itemTableWidget.transition === 'scroll-down'
      ) {
        <div class="carousel-viewport">
          <div
            class="carousel-track"
            [class.scroll-left]="itemTableWidget.transition === 'scroll-left'"
            [class.scroll-right]="itemTableWidget.transition === 'scroll-right'"
            [class.scroll-up]="itemTableWidget.transition === 'scroll-up'"
            [class.scroll-down]="itemTableWidget.transition === 'scroll-down'"
            [style.--carousel-duration-ms]="(carouselLoopDurationMs$ | async) + 'ms'"
            [style.--carousel-translate-percent]="(carouselLoopTranslatePercent$ | async) + '%'"
          >
            @for (page of pagesLoop$ | async; track $index) {
              <div
                class="item-grid carousel-page"
                [style.grid-template-columns]="'repeat(' + (itemTableWidget.columns || 1) + ', minmax(0, 1fr))'"
                [style.grid-template-rows]="'repeat(' + (itemTableWidget.rows || 1) + ', minmax(0, 1fr))'"
              >
                @for (item of page; track item.uuid) {
                  @if (itemTableWidget.card_type === ItemTableCardType.STANDARD_TABLE) {
                    <gb-presenter-widget-item-table-card-standard
                      [item]="item"
                      [itemTableWidget]="itemTableWidget"
                      [itemTypeTranslateKey]="getItemTypeTranslateKey(item)"
                    ></gb-presenter-widget-item-table-card-standard>
                  }
                  @if (itemTableWidget.card_type === ItemTableCardType.COMPACT_TABLE) {
                    <gb-presenter-widget-item-table-card-compact
                      [item]="item"
                      [itemTableWidget]="itemTableWidget"
                      [itemTypeTranslateKey]="getItemTypeTranslateKey(item)"
                    ></gb-presenter-widget-item-table-card-compact>
                  }
                }
              </div>
            }
          </div>
        </div>
      }
    } @else {
      <gb-presenter-widget-placeholder>
        <h1 translate="PRESENTER.WIDGET_TYPE.ITEM_TABLE"></h1>
        <span translate="PRESENTER.NO_ITEMS"></span>
      </gb-presenter-widget-placeholder>
    }
  } @else {
    <gb-skeleton-loader
      [columns]="itemTableWidget.columns || 5"
      [rows]="itemTableWidget.rows || 1"
      direction="grid"
      borderRadius="0.9cqw"
      [gap]="0.7"
      gapUnit="cqw"
    ></gb-skeleton-loader>
  }
</div>
